import { TypedDocumentNode } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { Mutation, MutationOnboardingChooseProviderArgs, Provider } from 'graphql/generated/graphqlTypes';
import { CHOOSE_PROVIDER } from 'graphql/mutations';
import { setCurrentTenantAction } from 'state/actions/currentTenant';
import { ignoreHandledMutationError } from 'utils/Mutation/ignoreHandledMutationError';
import { BaseHookProps } from '../shared/types';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const CHOOSE_PROVIDER_TYPED: TypedDocumentNode<
  Pick<Mutation, 'onboardingChooseProvider'>,
  MutationOnboardingChooseProviderArgs
> = CHOOSE_PROVIDER;

const useChooseProvider = ({ handleFetchError }: BaseHookProps) => {
  const [chooseProviderMutation, { loading }] = useMutation(CHOOSE_PROVIDER_TYPED, {
    onCompleted: (data) => {
      setCurrentTenantAction(data.onboardingChooseProvider);
    },
    onError: () => {
      handleFetchError('Error while choosing provider');
    }
  });

  const chooseProvider = async (provider: Provider) => {
    // Failure is already handled in the mutation's onError, so the rejection is ignored here.
    await ignoreHandledMutationError(
      chooseProviderMutation({
        variables: {
          provider
        }
      })
    );
  };

  return {
    loading,
    chooseProvider
  };
};

export default useChooseProvider;
